import * as React from 'react';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps } from 'theme/jss-types';
import { formFields } from 'components/create-consignment/create-modal.constants';
import { useTranslation } from 'react-i18next';
import {
    Col,
    Form,
    FormInstance,
    Input,
} from 'antd';

const styles = () => ({
    formItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        '& .ant-checkbox + span': {
            color: '#111111',
            fontSize: 14,
            fontWeight: 600,
        },
    },
    title: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
        marginLeft: 4,
    },
    inFavour: {
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        color: '#333333',
        fontSize: 12,
    },
});

interface IProps extends StylesProps<ReturnType<typeof styles>>, ReturnType<typeof mapStateToProps> {
    form: FormInstance;
    params: any;
}

const CODInFavourField = (props: IProps) => {
    const { t } = useTranslation();
    const {
        classes,
        form,
        params,
    } = props;
    const {
        ConsignmentCategory,
        IsCOD,
        InFavour,
    } = formFields;

    const { getValidationRules, getIsRequiredValidation, disabledFields = {} } = params;
    const consignmentCategory = Form.useWatch(ConsignmentCategory.key, form);
    const isCodValue = Form.useWatch(IsCOD.key, form);

    if (consignmentCategory === 'international') return <></>;
    if (isCodValue && isCodValue === 'no') return <></>;

    return (
        <Col span={24} xs={24} sm={24} md={12}>
            <div className={classes.inFavour}>
                <span className={classes.label}>
                    {t(InFavour.key)}
                    {getIsRequiredValidation(InFavour.key) && '*'}
                </span>
                <Form.Item
                    name={InFavour.key}
                    initialValue={InFavour.defaultValue}
                    valuePropName={InFavour.valuePropName}
                    className={classes.inFavour}
                    rules={getValidationRules(InFavour)}
                >
                    <Input
                        type="text"
                        placeholder={t('in_favour_placeholder')}
                        disabled={!!disabledFields[InFavour.key]}
                    />
                </Form.Item>
            </div>
        </Col>
    );
};

const mapStateToProps = () => {
    return {};
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
};

export default GenericHoc(hocConfig)(CODInFavourField);
